/**
 * Les cabinets — chunk 9.AS.1.
 *
 * Module dédié plutôt qu'un `api.get` dans le composant, pour la raison qui a
 * cassé le test de l'AppShell au premier essai : importer `lib/api` depuis un
 * composant monté dans la coquille tire tout le client Supabase dans son graphe
 * de modules. Les autres éléments de la barre du haut passent tous par un module
 * de requêtes (`deadlines`), que les tests savent simuler. Celui-ci fait pareil.
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

export type Cabinet = {
  id: string;
  name: string;
  slug: string;
  status: string;
};

/** La liste des cabinets — réservée au super_admin par l'API (403 sinon). */
export function useTenants(actif: boolean) {
  return useQuery({
    queryKey: ["tenants", "list"],
    queryFn: () => api.get<{ items: Cabinet[] }>("/v1/tenants?limit=100"),
    enabled: actif,
    // La liste bouge rarement, et le sélecteur est monté sur chaque écran.
    staleTime: 5 * 60_000,
  });
}

export function useCreateTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { name: string; slug: string; locale: string }) =>
      api.post<Cabinet>("/v1/tenants", { ...input, plan: "trial" }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["tenants", "list"] }),
  });
}
